var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9612 18.8892C15.871 18.8892 19.8511 14.9091 19.8511 9.99929C19.8511 5.08953 15.871 1.10938 10.9612 1.10938C6.05144 1.10938 2.07129 5.08953 2.07129 9.99929C2.07129 14.9091 6.05144 18.8892 10.9612 18.8892Z",
    fill: "url(#paint0_linear_14874_16187)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.0928 10.0137C8.77746 8.91596 10.5677 8.19225 11.4634 7.84259C14.0209 6.84425 14.5523 6.67083 14.8987 6.6651C14.9748 6.66384 15.1452 6.68156 15.2555 6.76559C15.3487 6.83654 15.3743 6.93238 15.3866 6.99965C15.3988 7.06692 15.4141 7.22016 15.402 7.33989C15.2634 8.70655 14.6637 12.0231 14.3586 13.5538C14.2295 14.2014 13.9753 14.4186 13.7293 14.4399C13.1945 14.486 12.7884 14.1082 12.2704 13.7895C11.4599 13.2909 11.002 12.9804 10.2152 12.4939C9.30599 11.9315 9.89541 11.6225 10.4136 11.1174C10.5492 10.9852 12.9055 8.97369 12.9511 8.79122C12.9568 8.7684 12.9621 8.68333 12.9083 8.63841C12.8544 8.59349 12.7749 8.60885 12.7176 8.62107C12.6363 8.63838 11.3415 9.4416 8.8331 11.0307C8.46557 11.2676 8.13267 11.383 7.8344 11.3769C7.50559 11.3703 6.87308 11.2024 6.40288 11.059C5.82615 10.883 5.36778 10.79 5.4077 10.4912C5.42849 10.3356 5.65685 10.1764 6.0928 10.0137Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14874_16187",
    x1: 10.9612,
    y1: 1.10938,
    x2: 10.9612,
    y2: 18.7573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.44217582aa13cdca58ef3791473801b9.svg";
export { ForwardRef as ReactComponent };